import React from "react";

export const SlidingComponent = ({
  name,
  toggleclass,
  type,
  toggleinputclass,
  spantext1,
  spantext2,
  currentState,
  onChange,
  checked,
  defaultChecked,
  slidingonClick,
  disabled,
}) => {
  return (
    <React.Fragment>
      <div className={toggleclass}>
        <div className="f16-500 mr-2">
          {currentState ? <b>{spantext1}</b> : spantext1}
        </div>
        <input
          type={type}
          name={name}
          className={`${toggleinputclass}`}
          onChange={onChange}
          defaultChecked={defaultChecked}
          onClick={slidingonClick}
          checked={checked}
          disabled={disabled}
        />
        <div className="f16-500 pl-2">
          {currentState ? spantext2 : <b>{spantext2}</b>}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SlidingComponent;
